<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8PQQ1w/images/cover.jpg?1685327423783" alt="This image is the cover for the book A Crack in Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Crack in Time
      </h1>
      <p class="bookDescription body article font2">
        <p>In the summer of 1970, eighteen-year-old Micha Dahl has a plan to beat the draft: work, save, enroll in college, and get a student deferment from the jungles of Vietnam. Micha is almost certain he’s gay,  but in his hometown where everyone knows everybody and his favorite brand of beer, approaching the wrong man could turn very unhealthy very fast.</p> <p>Micha is not expecting  his first male love to walk into the ma-and-pa café where he works, until USAF Second Lieutenant Trent Valiston takes a table in Micha’s section. But what starts as a summer fling leads to a forty-year loss of all that’s worth having.</p><p><b>A Bittersweet Dreams title: </b>It's an unfortunate truth: love doesn't always conquer all. Regardless of its strength, sometimes fate intervenes, tragedy strikes, or forces conspire against it. These stories of romance do not offer a traditional happy ending, but the strong and enduring love will still touch your heart and maybe move you to tears.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee James
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b832a1b